














import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import { projectVariables } from '../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-1-introduction'


@Component
class DigitalCurrency1DigitalCurrencySymbol extends Vue {
  @Prop({ default: 30 }) iconSize?: number
  @Prop({ default: true }) showTooltip?: boolean

  digitalCurrencyName: string = projectVariables.digitalCurrencyName
  digitalCurrencySymbolImageIconUrl: string = projectVariables.digitalCurrencySymbolImageIconUrl
}

export default DigitalCurrency1DigitalCurrencySymbol

